/** When is a check-in due, and what goes into one. Pure. */

import { addDays, daysBetween, weekday } from './days.ts'
import { expenditureOn, type Model } from './model.ts'
import { trendOn } from './trend.ts'

export function checkinDue(today: string, lastCheckin: string | null, programStart: string | null,
  checkinWeekday: number | null | undefined): boolean {
  const anchor = lastCheckin ?? programStart
  if (!anchor) return false
  const since = daysBetween(anchor, today)
  if (since >= 7) return true
  return since >= 5 && checkinWeekday !== null && checkinWeekday !== undefined && weekday(today) === checkinWeekday
}

export type WeekReview = {
  from: string; to: string
  loggedDays: number; avgIntake: number | null
  weighIns: number; trendStart: number | null; trendEnd: number | null
  eOld: number | null; eNow: number | null; onTarget: number
}

/** The seven days ending yesterday. */
export function weekReview(m: Model, lastCheckin: string | null): WeekReview {
  const to = addDays(m.today, -1)
  const from = addDays(m.today, -7)
  let logged = 0, sum = 0, weigh = 0, hit = 0
  for (let i = 0; i < 7; i++) {
    const d = addDays(from, i)
    const s = m.summaries.get(d)
    if (s?.valid) {
      logged++; sum += s.kcal
      if (s.target && Math.abs(s.kcal - s.target.kcal) <= 0.1 * s.target.kcal) hit++
    }
    if (m.weighDays.has(d)) weigh++
  }
  return {
    from, to, loggedDays: logged, avgIntake: logged ? sum / logged : null, weighIns: weigh,
    trendStart: trendOn(m.trend, addDays(from, -1)), trendEnd: trendOn(m.trend, to),
    eOld: expenditureOn(m, lastCheckin ?? addDays(m.today, -7)) ?? m.prior, eNow: m.eNow, onTarget: hit,
  }
}
